import { render, staticRenderFns } from "./Effect.vue?vue&type=template&id=1800e475&scoped=true&"
import script from "./Effect.vue?vue&type=script&lang=js&"
export * from "./Effect.vue?vue&type=script&lang=js&"
import style0 from "./Effect.vue?vue&type=style&index=0&id=1800e475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1800e475",
  null
  
)

export default component.exports